import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "navbar-content" };
import { ref, onMounted, onUnmounted } from 'vue';
// 添加这行
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavBar',
    props: {
        white: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const isScrolled = ref(false);
        const isMenuOpen = ref(false);
        const handleScroll = () => {
            isScrolled.value = window.scrollY > 50;
        };
        const toggleMenu = () => {
            isMenuOpen.value = !isMenuOpen.value;
        };
        // const isActive = (path: string) => {
        //   route.path === path;
        // };
        onMounted(() => {
            window.addEventListener('scroll', handleScroll);
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll);
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("nav", {
                class: _normalizeClass(["navbar", { 'scrolled': isScrolled.value || props.white }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "navbar-brand" }, [
                            _createElementVNode("h1", { class: "company-name" }, "北京甜蜜双排科技有限公司")
                        ], -1)),
                        _createElementVNode("div", {
                            class: _normalizeClass(["navbar-menu", { 'open': isMenuOpen.value }])
                        }, [
                            _createVNode(_component_router_link, {
                                to: "/",
                                class: "nav-link",
                                "active-class": "active"
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("首页")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_router_link, {
                                to: "/news",
                                class: "nav-link",
                                "active-class": "active"
                            }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode("行业资讯")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_router_link, {
                                to: "/about",
                                class: "nav-link",
                                "active-class": "active"
                            }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("关于我们")
                                ])),
                                _: 1
                            })
                        ], 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["btn btn-primary navbar-button", { 'scrolled-button': isScrolled.value || props.white }])
                        }, "抢先预约", 2),
                        _createElementVNode("button", {
                            class: "menu-toggle",
                            onClick: toggleMenu
                        }, _cache[3] || (_cache[3] = [
                            _createElementVNode("span", null, null, -1),
                            _createElementVNode("span", null, null, -1),
                            _createElementVNode("span", null, null, -1)
                        ]))
                    ])
                ])
            ], 2));
        };
    }
});
